import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.expand?.push("properties");
});
